import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import PortalPage from "./PortalPage";
import MobilePortalPage from "./MobilePortalPage";

const MOBILE_BREAKPOINT = 768;

/** Consider mobile if width OR height is below breakpoint, so phones stay mobile in landscape. */
function isMobileViewport() {
  if (typeof window === "undefined") return false;
  return window.innerWidth < MOBILE_BREAKPOINT || window.innerHeight < MOBILE_BREAKPOINT;
}

export default function PortalRouter() {
  const [searchParams] = useSearchParams();
  const forceMobile = searchParams.get("mobile") === "1";

  const [isMobile, setIsMobile] = useState(
    () => forceMobile || isMobileViewport()
  );

  useEffect(() => {
    if (forceMobile) {
      setIsMobile(true);
      return;
    }
    const check = () => setIsMobile(isMobileViewport());
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [forceMobile]);

  return isMobile ? <MobilePortalPage /> : <PortalPage />;
}
